import type { FeedbackRequest } from "./types";

const ROLE: Record<FeedbackRequest["kind"], string> = {
  challenge:
    "You are an experienced game design mentor reviewing a designer's response to a practice design challenge.",
  interview:
    "You are a senior hiring manager and game design mentor giving feedback on a practice interview answer.",
};

export function buildSystemPrompt(kind: FeedbackRequest["kind"]): string {
  return [
    ROLE[kind],
    "Give honest, specific, encouraging feedback that helps the person improve their game-design thinking.",
    "Be concrete: reference their actual ideas, not generic advice. Keep it tight — no preamble, no flattery.",
    "Respond in GitHub-flavored Markdown using EXACTLY these sections and headings:",
    "",
    "**Score:** a single line `**Score:** N/100` reflecting design quality.",
    "### What works — 2-4 bullets on genuine strengths in their answer.",
    "### Gaps & risks — 2-4 bullets on what's missing, weak, or risky.",
    "### Make it stronger — 2-4 concrete, actionable suggestions tied to their answer.",
    "### One thing to try next — a single sentence prompt to push their thinking further.",
    "",
    "Do not include any other sections. Use **bold** for key terms. Keep the whole reply under ~300 words.",
  ].join("\n");
}

export function buildUserPrompt(req: FeedbackRequest): string {
  const lines: string[] = [];
  lines.push(`# ${req.kind === "challenge" ? "Design challenge" : "Interview question"}`);
  lines.push(`**Title:** ${req.title}`);
  if (req.context) lines.push(`**Context:** ${req.context}`);
  lines.push("");
  lines.push("## Prompt");
  lines.push(req.task);
  if (req.idealPoints && req.idealPoints.length) {
    lines.push("");
    lines.push("## Rubric — points a strong answer tends to cover");
    for (const p of req.idealPoints) lines.push(`- ${p}`);
  }
  lines.push("");
  lines.push("## The designer's answer");
  lines.push(req.response);
  lines.push("");
  lines.push("Now give your feedback in the required format.");
  return lines.join("\n");
}
